import styled from "styled-components"
import Spinner from "components/EvtKit/loading-spinner/LoadingSpinner"
import { CellLogo } from "components/EvtKit/list-items/CellLogo"
import { CellLink } from "components/EvtKit/list-items/CellLink"
import { CellText } from "components/EvtKit/list-items/CellText"
import { CellSwitch } from "components/EvtKit/list-items/CellSwitch"
import { CellActionButtons } from "components/EvtKit/list-items/CellActionButtons"
import { useAppSelector } from "reducers/store"

const ListItemsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  gap: 16px;
  margin-top: 48px;
  padding-right: 24px;
`

const ListItemsContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  background-color: ${(props) => props.theme.palette.white};
  box-shadow: 0px 2px 6px 0px rgba(13, 10, 44, 0.08);
`

interface ProductListProps {
  onClickEdit: (item: any) => void
  onClickSwitch: (item: App.Product) => void
}

const ProductList = (props: ProductListProps) => {
  const { onClickEdit, onClickSwitch } = props

  const { data, loading } = useAppSelector((state) => state.product.productList)

  return (
    <>
      <ListItemsContainer>
        {loading && <Spinner />}
        {!loading &&
          data?.map((item, index) => (
            <ListItemsContent key={index}>
              <CellLogo title={item.name} image={item.productInfo.image} />
              <CellLink title="URL" link={item.productInfo.federationUrl} partial />
              <CellLink title="Documentação API" link={item.productInfo.docLink} partial />
              <CellText title="Planos" content={`${item.purchasePlanCount}`} />
              <CellText title="Produto Federado" content={item.isFederated ? "SIM" : "NÃO"} />
              <CellText title="Produto Externo" content={item.isExternal ? "SIM" : "NÃO"} />
              <CellSwitch initialState={item.productInfo.isPublished} onClickSwitch={() => onClickSwitch(item)} />
              <CellActionButtons onClickEdit={() => onClickEdit(item)} />
            </ListItemsContent>
          ))}
      </ListItemsContainer>
    </>
  )
}

export default ProductList
